import { render } from "./ArtistEditing.vue?vue&type=template&id=4d0d1257"
import script from "./ArtistEditing.vue?vue&type=script&lang=js"
export * from "./ArtistEditing.vue?vue&type=script&lang=js"
script.render = render

export default script